import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge configured to respect our `tw-` prefix so utility de-duplication
 * still works correctly during the migration period.
 */
const customTwMerge = extendTailwindMerge({
  prefix: 'tw-',
});

/**
 * cn — the canonical class-name combiner used across all shared/ui primitives.
 *
 * @example
 *   <div className={cn("tw-flex tw-gap-2", isActive && "tw-bg-primary")} />
 */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
